// eslint-disable-next-line
const $win = $(window);
const $htmlBody = $('html, body');

let scrollPos = 0;
let isPagerInProgress = false;

const $toTopBtn = $('.to-top');
const $countriesBtn = $('.m-ilink--countries');
const $headerTop = $('.m-header__top');
const $mobileMenu = $('.m-nav-mobile');
const $sideBottom = $('.m-logo-corner');
const $powerline = $('.wrapper-pl');
const $signet = $('.m-side__bottom');
const $heroSliderControls = $('.m-hero-slider__ctrls');
const $sidebar = $('.m-side');

function scrollTo(pos) {
  $htmlBody.animate({ scrollTop: pos }, '300', () => {
    setTimeout(() => {
      isPagerInProgress = false;
    }, 100);
  });
}

function createPager($wrapper) {
  let result = '';
  $('[data-section-name]').each(function forEachSection(index) {
    const $this = $(this);
    if ($this.attr('data-section-hint-title')) {
      result += `
          <li class="m-page-pager__item">
              <button class="m-page-pager__btn" data-section-target="${$this.attr('data-section-name')}">${index + 1}</button>
              <span class="m-page-pager__label">${$this.attr('data-section-hint-title') || ''}</span>
          </li>
      `;
    } else {
      result += `
          <li class="m-page-pager__item">
              <button class="m-page-pager__btn" data-section-target="${$this.attr('data-section-name')}">${index + 1}</button>
          </li>
      `;
    }
  });
  if (result) {
    $wrapper.html(`<ul class="m-page-pager__list">${result}</ul>`);
  }
}

// on mouse over sidebar set bg color
$sidebar.hover(function () {
  $(this).addClass('set-bg-black');
}, function () {
  if (!($('.m-nav__sub').hasClass('m-nav-sub') && $('.m-nav__sub').hasClass('open'))) {
    if (!$win.scrollTop() > 0) {
      $(this).removeClass('set-bg-black');
    }
  }
});

$('.m-close-btn, .main').click(function () {
  if (!$win.scrollTop() > 0) {
    $sidebar.removeClass('set-bg-black');
  }
});

// scroll effects
$win.scroll(function scroll() {
  const st = $(this).scrollTop();
  const isScrollingDown = st > 0 && st > scrollPos;
  const isScrollingUp = !isScrollingDown;
  const scrollHeight = $(document).height();
  const scrollPosition = $(window).height() + $(window).scrollTop();
  const endOfDocument = (scrollHeight - scrollPosition) / scrollHeight === 0;

  if (!$mobileMenu.hasClass('mm--open')) {
    if (isScrollingDown) {
      $headerTop.addClass('scroll-down');
      $headerTop.removeClass('scroll-up');
      if ($countriesBtn.hasClass('active')) {
        $countriesBtn.removeClass('active').next().removeClass('open');
      }
    } else if (!isPagerInProgress) {
      $headerTop.removeClass('scroll-down');
      $headerTop.addClass('scroll-up');
    }
  }

  if ($win.scrollTop() > 0) {
    $sidebar.addClass('set-bg-black');
    $headerTop.removeClass('pos-top');
  } else {
    $sidebar.removeClass('set-bg-black');
    $headerTop.addClass('pos-top');
  }


  // Logo left sidebar Hidden on Top and Bottom of the page
  if ($win.scrollTop() <= 0 || st > 0 && st > scrollPos || $htmlBody.height() <= $win.height() + $win.scrollTop() + 100) {
    $sideBottom.removeClass('m-logo-corner--show');
  } else {
    $sideBottom.addClass('m-logo-corner--show');
  }

  // Hero slider controls moved a bit up when on top of the page,
  // because of the powerline visibility
  if ($win.scrollTop() <= 0) {
    $heroSliderControls.addClass('up');
  } else {
    $heroSliderControls.removeClass('up');
  }

  // Powerline show when on top of the page
  // if ($win.scrollTop() <= 0) {
  //     $powerline.addClass('fixed');
  // } else {
  //     $powerline.removeClass('fixed');
  // }
  if (isScrollingUp || endOfDocument) {
    $powerline.removeClass('fade');
    $signet.removeClass('show');
  } else {
    $powerline.addClass('fade');
    $signet.addClass('show');
  }

  if ($win.scrollTop() > 300) {
    $toTopBtn.addClass('show');
  } else {
    $toTopBtn.removeClass('show');
  }

  scrollPos = st;
}).trigger('scroll');

// jump to top
$toTopBtn.on('click', (e) => {
  e.preventDefault();
  scrollTo(0);
});

// pager
createPager($('.m-page-pager'));
const $pagerBtn = $('.m-page-pager__btn');

$pagerBtn.on('click', function pagerBtnClick(e) {
  e.preventDefault();
  const $this = $(this);
  const target = $this.attr('data-section-target');
  const $targetElement = target ? $(`[data-section-name='${target}']`) : [];
  if ($targetElement.length) {
    isPagerInProgress = true;
    $headerTop.addClass('scroll-down');
    scrollTo($targetElement.offset().top + 2 - 64);
  }
});
